
import Vue from 'vue';
import { Tags, Icon } from '@descomplica/vue-components';
import { ClassroomModel } from '@descomplica/dex-models';
import ProgressBar from '../progress/ProgressBar.vue';
import scrollDirective from '@/directives/scroll';
import PostgradMicrocertificateProgress from '../microcertificate/postgrad/PostgradMicrocertificateProgress.vue';
import LineSkeleton from '../skeletons/atoms/LineSkeleton.vue';

export default Vue.extend({
  components: {
    ProgressBar,
    Tags,
    Icon,
    LineSkeleton,
    PostgradMicrocertificateProgress,
  },
  directives: {
    scroll: scrollDirective,
  },
  props: {
    classroom: {
      required: true,
      type: Object as Vue.PropType<ClassroomModel>,
    },
  },
  data() {
    return {
      isTitle: false as Boolean,
    };
  },
  computed: {
    microcertificates(): string[] {
      return [];
    },
    header(): any {
      return this.$refs.header;
    },
    isLoadingClassroomData(): boolean {
      return this.$store.getters.isLoadingClassroomData;
    },
    isPostgradMicrocertificateEnabledForBoard(): boolean {
      const boardsClassroomIds = this.classroom.boardsClassroomsByClassroomId;

      if (boardsClassroomIds.length !== 1) {
        // in postgrad context, a classroom should always have only one board
        return false;
      }

      const boardClassroom = this.$store.getters.boardsClassroomById(boardsClassroomIds[0]);

      if (!boardClassroom) {
        return false;
      }

      return boardClassroom.board?.hasPostgradMicrocertificateEnabled ?? false;
    },
    canViewPostgradMicrocertificate(): boolean {
      return (
        this.$store.getters.isPostgraduateCourse && this.isPostgradMicrocertificateEnabledForBoard
      );
    },
  },
  methods: {
    handlerScroll() {
      this.isTitle = window.scrollY > this.header.offsetTop;
    },
  },
});
